import { IntercomUserSearchResult } from '@just-insure/api';
import { api } from '../httpService';

export const getIntercomUserDetails = async (userId: string) =>
  await api<IntercomUserSearchResult>('get', `/users/${userId}/intercom`);
